import { set } from 'lodash';

import { GroupQueryResult } from '@work4all/models/lib/Classes/GroupQueryResult.entity';
import { AggregationType } from '@work4all/models/lib/Enums/AggregationType.enum';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

// Common mappings for ERP entities
const COMMON_ERP_SUM_MAPPINGS = {
  detailsnetValueMainCurrency: 'details.netValueMainCurrency',
  detailsgrossValueMainCurrency: 'details.grossValueMainCurrency',
};

// Entity-specific mappings with special cases
const CORRECT_ALIASES_BY_ENTITY = {
  [Entities.salesOpportunities]: {
    detailsrated: 'details.rated',
  },
  // Apply common ERP mappings to all relevant entities
  [Entities.invoice]: COMMON_ERP_SUM_MAPPINGS,
  [Entities.deliveryNote]: COMMON_ERP_SUM_MAPPINGS,
  [Entities.calculation]: COMMON_ERP_SUM_MAPPINGS,
  [Entities.demand]: COMMON_ERP_SUM_MAPPINGS,
  [Entities.order]: COMMON_ERP_SUM_MAPPINGS,
  [Entities.offer]: COMMON_ERP_SUM_MAPPINGS,
  [Entities.contract]: COMMON_ERP_SUM_MAPPINGS,
};

export const footerDataByGroupByResult = (
  result: GroupQueryResult,
  entity: Entities
): unknown => {
  const data: object = {};

  if (result.data.length !== 1) {
    console.error('Unexpected length of groupBy query:', result.data.length);
    return data;
  }

  const row = result.data[0];

  for (const field of row.data) {
    const shouldParseAsNumber = field.aggregationType !== AggregationType.COUNT;

    /**
     * A workaround to support nested aliases.
     * The backend treats `.` as an illegal character and removes it
     * from the `alias` value, making it impossible to map it back.
     *
     * Context: https://work4all.slack.com/archives/C03LXTT1RL4/p1748852659940229
     */
    const correctAlias = CORRECT_ALIASES_BY_ENTITY[entity]?.[field.alias];
    const alias = correctAlias ?? field.alias;

    const value = shouldParseAsNumber
      ? tryParseAsNumber(field.value)
      : field.value;

    set(data, alias, value);
  }

  return data;
};

const tryParseAsNumber = (value: string): number | null => {
  // The returned value is not serialized correctly. Try to parse anyway.
  value = value.replace(/,/g, '.');

  const parsed = Number(value);
  return Number.isNaN(parsed) ? null : parsed;
};
